import { render, staticRenderFns } from "./search-type-filters.vue?vue&type=template&id=72e7eee6"
import script from "./search-type-filters.vue?vue&type=script&lang=js"
export * from "./search-type-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports